import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  selected: {},
  isLoaded: false,
};

const issueSlice = createSlice({
  name: "issue",
  initialState,
  reducers: {
    setIssue: (state, { payload }) => {
      state.list = payload;
      state.isLoaded = true;
    },
    updateIssueToList: (state, { payload }) => {
      console.log('[issueSlice] Payload:', payload);
      state.list = state.list.map((item) =>
        item.id === payload.id ? payload : item
      );
    },
    updateChangeStatus: (state, { payload }) => {
      state.list = state.list.map((item) =>
        item.id === payload.id ? payload : item
      );
    },
    updateChangeExplanation: (state, { payload }) => {
      console.log('[issueSlice] Payload:', payload);
      state.list = state.list.map((item) =>
        item.id === payload.id ? payload : item
      );
    },
    setSelectedIssue: (state, { payload }) => {
      state.selected = payload;
    },
    clearSelectedIssue: (state, { payload }) => {
      state.selected = {};
    },
  },
});

export const {
  updateChangeExplanation,
  setIssue,
  updateIssueToList,
  updateChangeStatus,
  setSelectedIssue,
  clearSelectedIssue,
} = issueSlice.actions;
export default issueSlice.reducer;
